import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { useSettings } from "../../context/SettingsContext";
import { imgUrl } from "../../api";
import "./Navbar.css";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  const esInicio = location.pathname === "/";
  const { settings } = useSettings();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
      <nav className={`navbar ${esInicio && !scrolled ? "navbar-transparent" : "navbar-solid"}`}>
        <div className="container navbar-inner">
          <Link to="/" className="navbar-logo">
            {settings.logo_url
                ? <img src={imgUrl(settings.logo_url)} alt={settings.site_name} className="navbar-logo-img" />
                : <>
                  <span className="logo-icon">🏠</span>
                  <span className="logo-text">{settings.site_name || "InmobiliariaPlus"}</span>
                </>
            }
          </Link>

          <ul className={`navbar-links ${menuOpen ? "open" : ""}`}>
            <li><Link to="/" onClick={() => setMenuOpen(false)}>Inicio</Link></li>
            <li><Link to="/propiedades?operation=VENTA" onClick={() => setMenuOpen(false)}>Venta</Link></li>
            <li><Link to="/propiedades?operation=RENTA" onClick={() => setMenuOpen(false)}>Renta</Link></li>
            <li><Link to="/contacto" onClick={() => setMenuOpen(false)}>Contacto</Link></li>
            <li>
              <Link to="/propiedades" className="btn btn-accent btn-sm" onClick={() => setMenuOpen(false)}>
                Ver propiedades
              </Link>
            </li>
          </ul>

          <button className="hamburger" onClick={() => setMenuOpen(!menuOpen)} aria-label="Menú">
            <span /><span /><span />
          </button>
        </div>
      </nav>
  );
}
